import getApiClient from '@/plugins/api-client'

export default {
    getJob: function() {
        const self = this,
            api = getApiClient(self.$store),
            jobId = self.$route.params.id

        api.get(`/jobs/${jobId}`)
            .then(result => {
                self.job = result.data
            })
            .catch(error => {
                console.log(error)
            })
    },

    acceptJob: function() {
        const self = this,
            api = getApiClient(self.$store),
            jobId = self.$route.params.id

        api.patch(`/jobs/${jobId}/reply`, {status: 1}, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.showJobAcceptedDialog = true
                self.job = result.data
            })
            .catch(error => {
                if (error.response.status === 403) {
                    self.showJobAcceptErrorDialog = true
                    self.jobAcceptError = error.response.data['hydra:description']
                }
            })
            .finally(() => {
                self.$root.$emit('updateNewJobsCount')
            })
    },

    denyJob: function() {
        const self = this,
            api = getApiClient(self.$store),
            jobId = self.$route.params.id

        api.patch(`/jobs/${jobId}/reply`, {status: 2}, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.showJobDeniedDialog = true
                self.job = result.data
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                self.$root.$emit('updateNewJobsCount')
            })
    },

    cancelJob: function() {
        const self = this,
            api = getApiClient(self.$store),
            jobId = self.$route.params.id

        api.patch(`/jobs/${jobId}/cancel`, {status: 8}, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.cancelJobResult = self.jobCancelledMessage
                self.job = result.data
            })
            .catch(() => {
                self.cancelJobResult = 'Erro ao cancelar o job. Tente novamente mais tarde.'
            })
            .finally(() => {
                self.showCancelJobDialog = false
                self.showCancelJobResultDialog = true
            })
    }
}
